export default "__VITE_ASSET__CID9B4oc__"